import { CURRENCY_SYMBOLS } from "../constants/OptionsConstants";

export const findPlan = (products = [], productSlug, planName) => {
  const product = products.find((p) => p.slug === productSlug);
  if (!product) return null;

  return (
    (product.product_plans || []).find(
      (pp) =>
        pp.name === planName ||
        (pp.display_metadata?.title || "").toLowerCase() ===
          planName.toLowerCase()
    ) || null
  );
};

export const formatPlanPrice = (price, currency) => {
  if (price == null) return null;
  return `${CURRENCY_SYMBOLS[currency] || "£"}${(price / 100).toFixed(2)}`;
};
